import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';

const Title: React.FC<{
    title: string;
    helpDocUrl?: string;
    closeCallback?: () => void;
    showCloseButton?: boolean;
}> = ({ title, closeCallback, helpDocUrl, showCloseButton }) => {
    return (
        <div className="titleWrap">
            <div className="name">
                <span>{title}</span>
                {helpDocUrl ? (
                    <div className="help-icon">
                        <div className="tip">
                            <a href={helpDocUrl} target="_blank" rel="noreferrer">
                                帮助文档
                            </a>
                        </div>
                        <IconFont name="QuestionMarkCircleBold" fontSize={14} color="#333" />
                    </div>
                ) : null}
            </div>

            {showCloseButton ? <IconFont onClick={closeCallback} name="CrossBlack" fontSize={18} color="#333" /> : null}
        </div>
    );
};

export default Title;
